'use client';
import Link from 'next/link';
import Image from 'next/image';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';

import { blogPostUrl } from 'src/services/route-utils';
import Carousel from 'src/components/Carousel';

type Props = {
    posts: any[];
    duration?: number;
};

export default function BlogCarousel({ posts, duration = 10000 }: Props) {
    return (
        <section className="bg-dark-green relative h-[400px] md:h-[640px]">
            <Carousel
                items={posts}
                duration={duration}
                keyForItem={(item) => item.slug}
                contentForItem={(item, active, index, shouldLoadImage) => (
                    <>
                        {item.cover_image?.image && (
                            <Image
                                className="object-cover"
                                alt={item.name}
                                src={item.cover_image.image}
                                priority={index === 0}
                                loading={shouldLoadImage ? 'eager' : undefined}
                                placeholder={item.cover_image.placeholder}
                                sizes="100vw"
                                fill
                            />
                        )}
                        <div className="bg-radial-bottom-left absolute top-0 left-0 h-full w-full from-black/80 to-black/0" />
                        <div className="relative container mx-auto h-full px-4">
                            <div
                                className={`absolute w-5/6 text-white transition-all duration-1000 md:w-2/3 xl:w-1/2 ${
                                    active
                                        ? 'bottom-4 opacity-100 md:bottom-20'
                                        : '-bottom-1/2 opacity-25 md:-bottom-1/4'
                                }`}>
                                <Link
                                    className="decoration-2 underline-offset-8 hover:underline"
                                    href={blogPostUrl(item)}>
                                    <h2 className="text-3xl md:text-5xl xl:text-6xl 2xl:text-7xl">{item.name}</h2>
                                    <div
                                        className={`text-primary mt-4 inline-block rounded-full bg-white p-4 py-2 text-sm transition-all duration-300 md:px-8 md:text-base ${
                                            active ? 'opacity-100' : 'opacity-0'
                                        }`}>
                                        Citește articolul{' '}
                                        <HiOutlineArrowNarrowRight aria-hidden className="inline-block text-2xl" />
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </>
                )}
            />
            <div className="absolute top-4 left-0 w-full md:top-8">
                <div className="container mx-auto">
                    <h1 className="font-body bg-dark-green inline-block p-4 py-2 text-xs text-white md:text-sm">
                        Cele mai recente articole
                    </h1>
                </div>
            </div>
        </section>
    );
}
